import { render, staticRenderFns } from "./CKDecoupledEditor.vue?vue&type=template&id=41ad08b8&"
import script from "./CKDecoupledEditor.vue?vue&type=script&lang=js&"
export * from "./CKDecoupledEditor.vue?vue&type=script&lang=js&"
import style0 from "./CKDecoupledEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports